import {useContext} from 'react';

import NonCriticalContext from 'coreComponents/NonCriticalBoundary/NonCriticalContext';
import {ServerContext} from 'coreUtils/adapters/sdk';
import type {ShellGate} from 'coreUtils/ssrShell';

/**
 * Registry of the critical SSR work of the current request (see `coreUtils/ssrShell`).
 * `null` on the client, on legacy brands (no registry) and below a `NonCriticalBoundary`.
 */
const useShellGate = (): ShellGate | null => {
	const ctx = useContext(ServerContext) as {res?: {locals?: Record<string, unknown>}} | null;
	const isNonCritical = useContext(NonCriticalContext);

	if (isNonCritical) {
		return null;
	}

	return (ctx?.res?.locals?._shellGate as ShellGate | undefined) ?? null;
};

export default useShellGate;
